"use client";

import z from "zod";

import type { UseRequestQueryProps } from "../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../request/hooks/useRequestQuery";
import { keyMeTeacherResourceAccess } from "./keyMeTeacherResourceAccess";

export type UseRequestMeTeacherResourceAccessProps = UseRequestQueryProps;

export const useRequestMeTeacherResourceAccess = ({
  ...props
}: UseRequestMeTeacherResourceAccessProps = {}) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: z.boolean(),
      urlBackendPath: "/me/access/teacher-resource",
    },
    queryKey: keyMeTeacherResourceAccess(),
  }),
});
